import { render, staticRenderFns } from "./BaseButtonHelp.vue?vue&type=template&id=6c432558"
import script from "./BaseButtonHelp.vue?vue&type=script&lang=js"
export * from "./BaseButtonHelp.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonHelp.vue?vue&type=style&index=0&id=6c432558&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports